import * as types from '../actions/action-types';
import * as blockUtils from '../utils/BlockUtils';

const initialState = {
  data: {},
};

const managementReducer = function(state = initialState, action) {
  switch (action.type) {
    case types.MANAGEMENT_UPDATE:
      state.data[action.siteId] = {
        data: action.data,
        getDevicesError: action.data.operationError,
      };

      blockUtils.unblockUI();
      return Object.assign({}, state, {
        data: state.data,
      });
  }

  return state;
};

export default managementReducer;
